import $store from '~/services/StoreService';
import Constants from '~/config/Constants';
import type UserService from '~/services/UserService';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export default function corporate(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const store = $store();
  const user = store.getters['root/userService'] as UserService;

  function isCorporateAdmin(): boolean {
    return user.organizationRole === Constants.OrganizationRole.ADMIN;
  }

  function isMultiSeatSubscription(): boolean {
    return Number(user.subscription?.quantity) > 1;
  }

  if (user.isCorporate
    && isCorporateAdmin()
    && (isMultiSeatSubscription() || (user.hasUsageBasedPaywalling && user.isPartOfACorporateOrganization))) {
    return next();
  }

  window.location.href = '/admin';
}
